export default __webpack_public_path__ + "static/media/redux-flow.1d8ec674.gif";